import React, { useState, useContext, useEffect,useRef } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import MainContext from 'MainContext';
import TextArea from './text-area';
import { 
  ChatWrapper,
  MessageWrapper,
  MessageName,
  MessageDate,
  Space,
  StyledSubTitle,
  StyledLine,
} from './css';
import DateConvertor from 'components/date-convertor';
import * as API from '../../container/api';
import { Circle, StyledImage } from 'components/wrapper';
import { useTranslation } from 'react-i18next';

import Loading from 'components/loading';
import { Element } from 'components/invoice';
import Profile from "asset/profile.svg";

const MessagesLoadingWrapper = styled.div`
  margin-bottom: ${ (props)=> props.marginBottom };
  background-color: ${(props) => props.loading ? props.theme.cardBackground : 'unset'};
  top: 10vw;

`

const DefaultProfile = styled.img.attrs({
  src: Profile,
})`
  width: 1.874vw;
  height: 1.874vw;
  border-radius: 100%;
  object-fit: cover;
`;

const ChatBox = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { profile, socket, notifications, setNotificationsContext } = useContext(MainContext).login;
  const [commentInput, setCommentInput] = useState('');
  const [messages, setMessages] = useState([]);
  const { open, selectedOrder, invoiceId,updateOpenOrder } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const isSubscribed=useRef(false);
  const selectedOrderRef=useRef({});
  selectedOrderRef.current=selectedOrder;
  

  useEffect(() => {
    if (!open) {
      setMessages([]);
      if (socket && selectedOrder._id) {
        socket.emit('leaveRoom', {
          chatroomId: selectedOrder._id,
        });
      }
    } else {
      if (socket) {
        getComments();
        socket.emit('joinRoom', {
          chatroomId: selectedOrder._id,
        });

        //subscriptions are mainained when socket disconnects and reconnects
        //so we only need to subscribe once
        //TODO unsubscribe when component is unmounted
        if(!isSubscribed.current){
          function onNewMessage(message){
            //if we read selectedOrder from props we will 
            
              selectedOrderRef.current.UIValues.messagesNO++;
              updateOpenOrder(invoiceId,selectedOrderRef.current);
              updateMessages(message);
        }
          socket.on('newMessage', onNewMessage);
          isSubscribed.current=true;
      }
      }
    }
    return () => {
      deleteNotification();
    };
  }, [open,socket]);

  const deleteNotification = async () => {
    if(!selectedOrder._id)
      return console.log('delete Notifs on null order');
    const notificationsHelpers = notifications.filter(
      (notification) => notification.order_id !== selectedOrder._id
    );
    setNotificationsContext(notificationsHelpers);
    await API.deleteNotification(selectedOrder._id);
  };


  const getComments = async () => {
    setLoading(true);
    try {
      await API.deleteNotification(selectedOrder._id);
      const result = await API.getComments(selectedOrder._id);
      selectedOrder.UIValues.messagesNO=result.messages.length;
      updateOpenOrder(invoiceId,selectedOrder);
      let messagesHelper = [];
      result.messages.map((message) => {
        let { create_at } = message;
        messagesHelper.push({
          message: message.message,
          messageId: message._id,
          name: message.user_id.first_name + ' ' + message.user_id.last_name,
          userProfile: message.user_id.profile_picture,
          userId: message.user_id._id,
          create_at,
        });
      });
      setMessages(messagesHelper);
    } catch (error) {
      console.log('error', error);
    }
    setLoading(false);
  };

  const updateMessages = (newMessage) => {
    setMessages(previous=>[...previous,newMessage]);
  };

  const onTextChange = (key, value) => {
    if (key === 'comment') {
      setCommentInput(value);
    } else if (key.includes('comment-')) {
      let helper = [...messages];
      messages.map((message, index) => {
        if ('comment-' + message.messageId === key) {
          helper[index].message = value;
        }
      });
      setMessages(helper);
    }
  };

  const onSaveNewComment = (e) => {
    socket.emit('chatroomMessage', {
      chatroomId: selectedOrder._id,
      message: commentInput,
      invoiceId,
    });
    setCommentInput('');
  };

  const deletComment = async (id) => {
    try {
      await API.deletComment(id);
      let helper = [...messages];
      messages.map((message, index) => {
        if (message.messageId === id) {
          helper.splice(index, 1);
        }
      });
      
        selectedOrder.UIValues.messagesNO=helper.length;
        updateOpenOrder(invoiceId,selectedOrder);
      
      
      setMessages(helper);
    } catch (error) {
      console.log(error);
    }
  };

  const editComment = async (id, message) => {
    try {
      await API.editComment(id, message);
    } catch (error) {
      console.log(error);
    }
  };

  let messagesArray = [];
  messages.map((message, index) => {
    messagesArray.unshift(
      <div key={message.messageId}>
        <MessageWrapper marginTop="2.602vw">
          <Circle size="1.874vw">
          {message.userProfile ?
             <StyledImage
                src={`${process.env.REACT_APP_STATISTIC_SERVICE_URL}/avatar/${message.userProfile}`}
              />:
              <DefaultProfile/>
            }
          </Circle>
          <Space width="0.676vw" />
          <MessageName theme={theme}>{message.name}</MessageName>
          
          <MessageDate theme={theme}>
            <DateConvertor value={message.create_at} withTime={true}/>
          </MessageDate>
          
        </MessageWrapper>
        <TextArea
          theme={theme}
          onChange={profile._id === message.userId ? onTextChange : (key, val) => console.log()}
          placeholder={t('dashboard.order modal.Comments')}
          inputTarget={'comment-' + message.messageId}
          value={message.message}
          deletComment={deletComment}
          editComment={editComment}
          message={message}
          profile={profile}
        />
      </div>
    );
  });

  return (
    <ChatWrapper>
      <StyledLine theme={theme} />
      <StyledSubTitle theme={theme}>{t('dashboard.order modal.Comments')}</StyledSubTitle>
      <TextArea
        onChange={onTextChange}
        placeholder={t('dashboard.order modal.Comments')}
        inputTarget={'comment'}
        value={commentInput}
        newComment={true}
        onSaveNewComment={onSaveNewComment}
      />

      {/* Loading for Messages */}
      {messagesArray?.length === 0 && !loading ? <></> : 
        <>
        {messagesArray}
        {loading && (
          <MessagesLoadingWrapper loading={true} marginBottom="5vw" >
          <Element left="2.0192vw" top="8.7vw" rtlDirection={rtlDirection} >
            <Loading width="1.874vw" height="1.874vw" borderRadius="50%" />
          </Element>
          <Element left="4.3vw" top="9.2vw" rtlDirection={rtlDirection}>
            <Loading width="6.8vw" height="1vw" borderRadius="0.832vw" />
          </Element>
          <Element left="4.3vw" top="10.8vw" rtlDirection={rtlDirection}>
            <Loading width="23.945vw" height="3vw" borderRadius="0.832vw" />
          </Element>
        </MessagesLoadingWrapper>
        )}
        </>
      }
    </ChatWrapper>
  );
};

export default ChatBox;
